import EducationCard from "../EducationCard/EducationCard";
import "./Education.scss";
import { useTranslation } from 'react-i18next';

const Education = () => {
    const { t } = useTranslation();
    const educationData = t("educationData", { returnObjects: true });

  return (
    <div className="education">
      <div className="education__container">
        <div className="education__title">
          <h3>{t("educationTitle")}</h3>
        </div>
        <div className="education__content">
          {educationData.map((edu, idx) => (
            <EducationCard
              key={idx}
              university={edu.university}
              field={edu.field}
              period={edu.period}
              content={edu.content}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Education;